<template>
  <div class="container">
    <div class="content">
      <div class="input-group">
        <input
          v-model="url"
          placeholder="输入 URL，例如 www.baidu.com"
          class="input-field"
        />
        <input
          v-model="description"
          placeholder="输入描述"
          class="input-field"
        />
        <div class="button-group">
          <button @click="myCreate" class="send-button">发送到-理财树公众号</button>
          <button @click="clearAll" class="clear-button">清除</button>
        </div>
      </div>
      <div class="message-container">
        <p v-if="message" class="message" :class="{ error: isError }">
          {{ message }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { ContactService } from '@/services/ContactService'
  import axios from 'axios'

  export default {
    data() {
      return {
        url: '',
        description: '',
        message: '',
        isError: false,
        contact: {},
      }
    },
    methods: {
      async sendToMake() {
        // const webhookUrl = 'https://hook.make.com/您的webhook唯一ID'; // 替换为您的Make.com webhook URL
        // const webhookUrl = 'https://hook.us1.make.com/ksuh3g9ii6n05rsu2ouue7fyj23s93nl'
        const webhookUrl = process.env.VUE_APP_WEBHOOK_URL
        try {
          const response = await axios.post(webhookUrl, {
            url: this.url,
            description: this.description,
          })
          this.message = `URL: ${this.url}\n描述: ${this.description}\n成功发送到 Make.com`
          this.isError = false
          console.log('响应:', response.data)
        } catch (error) {
          this.message = '发送失败: Network Error'
          this.isError = true
          console.error('错误:', error)
        }
      },

      clearAll() {
        this.url = ''
        this.description = ''
        this.message = ''
      },

      async sendToAirtable() {},

      async myCreate() {
        try {
          console.log('2025 04--------> this.url', this.url)

          this.contact = {
            url_from_user: this.url,
            url_desc: this.description,
          }
          console.log('2025 04--------> this.contact', this.contact)

          let response = await ContactService.airInsertRecord(this.contact)

          this.message = `URL: ${this.url}\n描述: ${this.description}\n成功发送到-理财树`
          this.isError = false
          console.log('响应:', response)

          // if (response) {
          //   console.log('2025 04--------> response', response)
          // } else {
          //   console.log('2025 04--------> response', response)
          // }
        } catch (error) {
          this.errorMessage = error
          this.message = '发送失败: Network Error'
          this.isError = true
          console.error('错误:', error)
        }
      },
    },
  }
</script>

<style scoped>
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #1e1e1e;
    color: white;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 80%;
    max-width: 500px;
  }

  .input-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .input-field {
    padding: 15px;
    font-size: 18px;
    margin-bottom: 15px;
    border: 2px solid #3a3a3a;
    border-radius: 5px;
    background-color: #2a2a2a;
    color: white;
  }

  .button-group {
    display: flex;
    justify-content: space-between;
  }

  .send-button,
  .clear-button {
    padding: 15px;
    font-size: 18px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .send-button {
    background-color: #4caf50;
    width: 70%;
  }

  .clear-button {
    background-color: #f44336;
    width: 25%;
  }

  .message-container {
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .message {
    margin: 0;
    font-size: 16px;
    text-align: center;
    white-space: pre-line;
  }

  .error {
    color: #ff6b6b;
  }
</style>
